import RootContextProvider from "./context/RootContext";
import { BrowserRouter } from "react-router-dom";
import "./local-override";//over ride local methods
import Layouts from "./layout";
import history from "./history";
import "./App.css";

function App() {
  return (
    <RootContextProvider>
      <BrowserRouter history={history}>
        <Layouts />
      </BrowserRouter>
    </RootContextProvider>
  );
}

export default App;
